module.exports = __webpack_public_path__ + "img/fifi.a5621750.png";